import { DocumentoDTO } from "../documentoDTO";
import { ClassificaDTO } from "../classificaDTO";
import { ClassificaGescorDTO } from "./classifica-gescorDTO";
import { DocumentoGescorDTO } from "./documeto-gescorDTO";
import { MetadatiProtocolloGescorDTO } from "./metadati-protocollo-gescorDTO";

export class CorrispondenzaArrivoDTO {
  oggetto: string;

  primario: DocumentoGescorDTO;

  allegati: DocumentoGescorDTO[];

  classifica: ClassificaGescorDTO[];

  riservata: Boolean;

  metadatiProtocollo: MetadatiProtocolloGescorDTO;
}
